import React, { createContext, useEffect, useRef, useState } from 'react';
import Lottie from 'react-lottie';
import { getallFolder } from '../utils/services/folderAPI';
import {
  unlockTemplate,
  getTemplateByCategory,
  getAllTemplate,
  getTemplateLockStatus,
  lockResource,
} from '../utils/services/templatesAPI';
import { waitForApproval } from '../utils/services/publishAPI';
import {
  createCustomerPortal,
} from '../utils/services/authAPI';
import {
  getAllVariables,
  saveVariable,
  getAllMailTemplates,
  waitForApprovalEmail,
} from '../utils/services/mailTemplateAPI';
import { getAllTemplates } from '../utils/services/shortMessageTemplateAPI';
import { generateTextFromData, detectLanguage } from '../utils/services/textGenerationAPI';
import animationData from '../components/CreateNewTemplate/createDocLottie.json';
import generateAIData from '../components/CreateNewTemplate/generatingAIContentLottie.json';
import writingAIData from '../components/CreateNewTemplate/writingAIContentLottie.json';
import Session from 'supertokens-web-js/recipe/session';
import OpenReplay from '@openreplay/tracker/cjs';
import { OPENREPLAY_DISABLE_SECURE_MODE } from '../utils/helper';
import { notification, Steps, Icon, message } from 'antd';
import { AIGenerationSteps, DividerLine } from './styles';
import { useHistory } from 'react-router-dom';
import trackerAssist from '@openreplay/tracker-assist';
// import { createServerEvent } from '../utils/createServerEvent';
// import { isInIframe } from '../utils/embedHelper';

export const AppStoreContext = createContext();
const { Step } = Steps;

const AppStoreProvider = ({ children }) => {
  let history = useHistory();

  const [categoryElements, setCategoryElements] = useState([]);
  const [categoryTemplates, setCategoryTemplates] = useState([]);
  const [editorTemplates, setEditorTemplates] = useState([]);

  // Onboarding
  const [loginVisible, setLoginVisible] = useState(false);
  const [emailVerificationVisible, setEmailVerificationVisible] = useState(false);
  const [ChekOutVerification, setChekOutVerification] = useState(false);
  const [onboardingStatus, setOnboardingStatus] = useState(false);
  const [userDetails, setUserDetails] = useState('');
  const { planMapping } = userDetails;
  const planType = planMapping?.user === 1 ? 'Free' : planMapping?.user === 5 ? 'Standard' : 'Premium';
  const [isEnterprise, setIsEnterprise] = useState(false);
  const [ssoSetup, setSSOSetup] = useState(null);
  const [ssoAuthClient, setAuthClient] = useState(null);

  const [documentVisible, setDocumentVisible] = useState(false);
  const [hasSession, setSession] = useState(false);
  const [folderList, setFolderList] = useState([]);
  const [userPermission, setUserPermission] = useState({});
  const [isTemplateEditable, setIsTemplateEditable] = useState(false);
  const [openLockedModal, setOpenLockedModal] = useState(false);
  const [lockedUserName, setLockedUserName] = useState(null);
  const [lockedUserId, setLockedUserId] = useState(null);
  const [error, setError] = useState(undefined);
  const [errorInfo, setErrorInfo] = useState([]);
  const [globalVariables, setGlobalVariables] = useState([]);
  const [documentVariables, setDocumentVariables] = useState([]);
  const [variablesFetched, setVariablesFetched] = useState(false);
  ////////////elements//////////////
  const [saveElementName, setSaveElementName] = useState('untitled');
  const [thumbnailId, setThumbnailId] = useState(undefined);
  const [elementDetails, setElementDetails] = useState(undefined);
  const [elementPageDetail, setElementPageDetail] = useState([]);
  ////////////templates//////////////
  const [templatesList, setTemplatesList] = useState([]);
  const [totalTemplates, setTotalTemplates] = useState([]);
  const [fetchingCategories, setFetchingCategories] = useState(true);
  const [resourceGroupId, setResourceGroupId] = useState(undefined);
  const [windowZoom, setWindowZoom] = useState(1);
  ///////////pdsSupportWidgetState////////
  const [sessionExist, setSessionExist] = useState(false);
  const [pageUpdationDetail, setPageUpdationDetail] = useState(undefined);
  const [countryList, setCountryList] = useState([]);
  const [organisationSetupPage, setOrganisationSetUpPage] = useState(false);
  const [isLdapConfigured, setIsLdapConfigured] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [licenseDetails, setLicenseDetails] = useState({});

  /// Generate AI text content 
  const [isAIGenerateText, setAIGenerateText] = useState(false);
  const [generateContentForText, setGenerateContentForText] = useState('');
  const [aiGeneratedContent, setAIGeneratedContent] = useState(undefined);
  const [pagesUpdatedByAI, setPagesUpdatedByAI] = useState([]);
  const [aiDataCurrentStep, setAICurrentStep] = useState(0);
  const [failedStep, setFailedStep] = useState(null);
  const [isLicenseExpired, setIsLicenseExpired] = useState(false);

  ///Authentication fails and Session Expired while embedding
  const [sessionExpired,setSessionExpired] = useState(false)
  const [reAuthenticate,setReAuthenticate] = useState(false)
  
  useEffect(() => {
    if (userDetails && checkUserAccess('client', ['DESIGNER', 'PUBLISHER'])) {
      updateGlobalVariables(null, 'fetchAllVariables');
    }
  }, [userDetails]);
  
  // useEffect(() => {
  //   let es = null;
  //   if(sessionExist && !isInIframe) {
  //     es = createServerEvent();
  //   }

  //   return () => {
  //     if(es) {
  //       es();
  //       console.log('SSE connection closed!');
  //     }
  //   }
  // }, [sessionExist]);

  const session = useRef();
  if (session.current === undefined) {
    session.current = Session;
  }
  const updateSessionExists = async () => {
    const sessionExists = await session.current.doesSessionExist({
      userContext: {},
    });
    setSessionExist(sessionExists);
    if (sessionExists === false) {
      const pdssWidget = window.document.getElementById('zohohc-asap-web-helper-main');
      if (pdssWidget) {
        pdssWidget.remove();
      }
    }
    return sessionExists;
  };
  const updateCategoryElements = (elements, updationType) => {
    switch (updationType) {
      case 'saveAllCategoryElements':
        setCategoryElements(elements);
        break;
      case 'saveCategoryElement':
        if (elements.categoryDetails && elements.categoryDetails.id) {
          const categoryIndex = categoryElements.findIndex(
            categoryDetails => categoryDetails.id === elements.categoryDetails.id,
          );
          if (categoryIndex >= 0) {
            let newCategoryElementsList = JSON.parse(JSON.stringify(categoryElements)); // Deep copying an Object
            newCategoryElementsList[categoryIndex].elements.push(elements.savedElement);
            setCategoryElements(newCategoryElementsList);
          } else {
            let newCategory = elements.categoryDetails;
            newCategory.elements = [];
            newCategory.elements.push(elements.savedElement);
            setCategoryElements(categoryElements => [...categoryElements, newCategory]);
          }
        }
        break;
      case 'deleteCategoryElement':
        if (elements && elements.categoryId && elements.id) {
          const categoryIndex = categoryElements.findIndex(
            categoryDetails => categoryDetails.id === elements.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryElementsList = JSON.parse(JSON.stringify(categoryElements)); // Deep copying an Object
            const categoryElementsList = categoryElements[categoryIndex].elements;
            const updatedCategoryElementsList = categoryElementsList.filter(element => {
              return element.id !== elements.id;
            });
            newCategoryElementsList[categoryIndex].elements = updatedCategoryElementsList;
            setCategoryElements(newCategoryElementsList);
          }
        }
        break;
      case 'updateCategoryElementTag':
        if (elements && elements.categoryId && elements.id) {
          const categoryIndex = categoryElements.findIndex(
            categoryDetails => categoryDetails.id === elements.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryElementsList = JSON.parse(JSON.stringify(categoryElements)); // Deep copying an Object
            const categoryElementsList = categoryElements[categoryIndex].elements;
            for (let data of categoryElementsList) {
              if (data.id === elements.id) {
                data.tags = elements.tags;
              }
            }
            newCategoryElementsList[categoryIndex].elements = categoryElementsList;
            setCategoryElements(newCategoryElementsList);
          }
        }
        break;
      case 'addNewElementCategory':
        setCategoryElements(categoryElements => [...categoryElements, elements]);
        break;
      case 'updateElementCategory':
        if (elements.id) {
          const categoryIndex = categoryElements.findIndex(
            categoryDetails => categoryDetails.id === elements.id,
          );
          if (categoryIndex >= 0) {
            let newCategoryElementsList = JSON.parse(JSON.stringify(categoryElements)); // Deep copying an Object
            newCategoryElementsList[categoryIndex].name = elements.name;
            setCategoryElements(newCategoryElementsList);
          }
        }
        break;
      case 'deleteElementCategory':
        if (elements.id) {
          const copiedCategoryElementsList = JSON.parse(JSON.stringify(categoryElements)); // Deep copying an Object
          const updatedCategoryElementsList = copiedCategoryElementsList.filter(category => {
            return category.id !== elements.id;
          });
          setCategoryElements(updatedCategoryElementsList);
        }
        break;
      default:
        break;
    }
  };

  const updateCategoryTemplates = (templates, updationType) => {
    switch (updationType) {
      case 'saveAllCategoryTemplates':
        setCategoryTemplates(templates);
        break;
      case 'addNewTemplateCategory':
        setCategoryTemplates(categoryTemplates => [...categoryTemplates, templates]);
        break;
      case 'updateTemplateCategory':
        if (templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.id === templates.id,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            newCategoryTemplatesList[categoryIndex].name = templates.name;
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }
        break;
      case 'deleteTemplateCategory':
        if (templates.id) {
          const copiedCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
          const updatedCategoryTemplatesList = copiedCategoryTemplatesList.filter(category => {
            return category.id !== templates.id;
          });
          setCategoryTemplates(updatedCategoryTemplatesList);
        }
        break;
      case 'deleteCategoryTemplate':
        if (templates && templates.categoryId && templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.categoryId === templates.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            const categoryTemplatesList = categoryTemplates[categoryIndex].templates || categoryTemplates[categoryIndex].documents;
            const updatedCategoryTemplatesList = categoryTemplatesList.filter(template => {
              return template.id !== templates.id;
            });
            if(categoryTemplates[categoryIndex].templates) {
              newCategoryTemplatesList[categoryIndex].templates = updatedCategoryTemplatesList;
            } else {
            newCategoryTemplatesList[categoryIndex].documents = updatedCategoryTemplatesList;
            }
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }
        break;
      case 'saveCategoryTemplate':
        if (templates.categoryDetails && templates.categoryDetails.id) {
          const categoryIndex = categoryTemplates.findIndex(
            categoryDetails => categoryDetails.categoryId === templates.categoryDetails.categoryId,
          );
          if (categoryIndex >= 0) {
            let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
            newCategoryTemplatesList[categoryIndex].templates.push(templates.savedTemplate);
            setCategoryTemplates(newCategoryTemplatesList);
          } else {
            let newCategory = templates.categoryDetails;
            newCategory.templates = [];
            newCategory.templates.push(templates.savedTemplate);
            setCategoryTemplates(categoryTemplates => [...categoryTemplates, newCategory]);
          }
        }
        break;
      case 'updateTemplatePages':
        let { categoryDetails, savedTemplate } = templates;
        const { categoryId, pages, id } = categoryDetails;
        if (categoryId && id && pages.length > 0) {
          const categoryIndex = categoryTemplates.findIndex(
            category => category.categoryId === categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = categoryTemplates[categoryIndex].templates.findIndex(
              templateDetails => templateDetails.id === id,
            );
            if (templateIndex >= 0) {
              let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].name =
                savedTemplate.name;
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].pages = pages;
              setCategoryTemplates(newCategoryTemplatesList);
            }
          } else {
            let newCategory = categoryDetails;
            newCategory.templates = [];
            newCategory.templates.push(savedTemplate);
            setCategoryTemplates(categoryTemplates => [...categoryTemplates, newCategory]);
          }
        }
        break;

      case 'updateTemplateTags':
        if (templates.categoryId && templates.id) {
          const categoryIndex = categoryTemplates.findIndex(
            category => category.categoryId === templates.categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = categoryTemplates[categoryIndex].templates?.findIndex(
              templateDetails => templateDetails.id === templates.id,
            );
            if (templateIndex >= 0) {
              let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].tags =
                templates.tags;
              setCategoryTemplates(newCategoryTemplatesList);
            }
          } else {
            return 0;
          }
        }
        break;

      case 'appendTemplatesToCategory':
        if (templates) {
          const { categoryId, page, allTemplates } = templates;
          let newCategoryTemplatesList = JSON.parse(JSON.stringify(categoryTemplates)); // Deep copying an Object
          if (categoryId && allTemplates.length > 0) {
            const categoryIndex = categoryTemplates.findIndex(
              categoryDetails => categoryDetails.categoryId === categoryId,
            );
            if (page === 1) {
              newCategoryTemplatesList[categoryIndex].templates = allTemplates;
            } else {
              newCategoryTemplatesList[categoryIndex].templates.push(...allTemplates);
            }
            setCategoryTemplates(newCategoryTemplatesList);
          }
        }

        break;

        case 'emptyTemplate':
        setCategoryTemplates([]);
        break;

      default:
        break;
    }
  };

  const updateEditorTemplate = (templates, updationType) => {
    switch (updationType) {
      case 'updateTemplatePages':
        let { categoryDetails, savedTemplate } = templates;
        const { categoryId, pages, id } = categoryDetails;
        if (categoryId && id && pages.length > 0) {
          const categoryIndex = editorTemplates.findIndex(
            category => category.categoryId === categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = editorTemplates[categoryIndex].templates.findIndex(
              templateDetails => templateDetails.id === id,
            );
            if (templateIndex >= 0) {
              let newCategoryTemplatesList = JSON.parse(JSON.stringify(editorTemplates)); // Deep copying an Object
              newCategoryTemplatesList[categoryIndex].templates[templateIndex].pages = pages;
              setEditorTemplates(newCategoryTemplatesList);
            }
          } else {
            let newCategory = categoryDetails;
            newCategory.templates = [];
            newCategory.templates.push(savedTemplate);
            setEditorTemplates(editorTemplates => [...editorTemplates, newCategory]);
          }
        }
        break;
      case 'updateTemplateTags':
        if (templates.categoryId && templates.id) {
          const categoryIndex = editorTemplates.findIndex(
            category => category.categoryId === templates.categoryId,
          );
          if (categoryIndex >= 0) {
            const templateIndex = editorTemplates[categoryIndex].templates.findIndex(
              templateDetails => templateDetails.id === templates.id,
            );
            if (templateIndex >= 0) {
              let newCategoryEditorTemplatesList = JSON.parse(JSON.stringify(editorTemplates)); // Deep copying an Object
              newCategoryEditorTemplatesList[categoryIndex].templates[templateIndex].tags =
                templates.tags;
              setEditorTemplates(newCategoryEditorTemplatesList);
            }
          } else {
            return 0;
          }
        }
        break;

      default:
        break;
    }
    updateCategoryTemplates(templates, updationType);
  };

  const updateListofFolders = (folder, updationType, responseId) => {
    switch (updationType) {
      case 'fetchAllFolders':
        setFolderList(folder);
        break;
      case 'createNewFolder':
        if (folder.parentId === null) {
          setFolderList(folderArray => [...folderArray, folder]);
        } else {
          let newFolderList;
          let updatedFolder = JSON.parse(JSON.stringify(folderList));
          for (let value of updatedFolder) {
            newFolderList = folderIteration(value, folder.parentId);
            if (newFolderList) {
              break;
            }
          }
          newFolderList.subFolder.push(folder);
          setFolderList(updatedFolder);
        }
        break;
      case 'deleteFolder':
        if (folder.parentId === null || folder.parentId === 0) {
          let Id = folderList.findIndex(value => value.id === responseId);
          folderList.splice(Id, 1);
        } else {
          let newFolderList;
          for (let data of folderList) {
            newFolderList = folderIteration(data, folder.parentId);
            if (newFolderList) {
              break;
            }
          }
          let Id = newFolderList.subFolder.findIndex(value => value.id === responseId);
          newFolderList.subFolder.splice(Id, 1);
        }
        setFolderList(folderList);
        break;
      case 'updateFolder':
        if (folder.parentId === null) {
          for (let data of folderList) {
            if (data.id === responseId) {
              data.name = folder.name;
            }
          }
        } else {
          let newFolderList;
          for (let data of folderList) {
            newFolderList = folderIteration(data, folder.parentId);
            if (newFolderList) {
              break;
            }
          }
          let folderIndex = newFolderList.subFolder.findIndex(value => value.id === responseId);
          newFolderList.subFolder[folderIndex].name = folder.name;
        }
        setFolderList(folderList);
        break;
      case 'addNewTemplate':
        let newTemplateList;
        let updatedFolder = JSON.parse(JSON.stringify(folderList));
        for (let value of updatedFolder) {
          newTemplateList = folderIteration(value, responseId);
          if (newTemplateList) {
            break;
          }
        }
        if (newTemplateList.elements.length === 0) {
          newTemplateList.elements.push(folder);
        } else {
          newTemplateList.elements &&
            newTemplateList.elements.forEach((obj, index) => {
              if (obj.elementId !== folder.elementId) {
                newTemplateList.elements.push(folder);
              } else {
                return 0;
              }
            });
        }
        setFolderList(updatedFolder);
        folderRefresh();
        break;
      case 'deleteFolderTemplate':
        let newFolderList;
        let updatedFolderElements = JSON.parse(JSON.stringify(folderList));
        for (let data of updatedFolderElements) {
          newFolderList = folderIteration(data, responseId);
          if (newFolderList) {
            break;
          }
        }
        let Index = newFolderList.elements.findIndex(value => value.id === folder.id);
        newFolderList.elements.splice(Index, 1);
        setFolderList(updatedFolderElements);
        break;
      default:
        break;
    }
  };

  const folderIteration = (obj, targetId, index) => {
    if (obj.id === targetId) {
      return obj;
    } else {
      if (obj.subFolder) {
        for (let item of obj.subFolder) {
          let checkParent = folderIteration(item, targetId, index);
          if (checkParent) {
            return checkParent;
          }
        }
      }
    }
  };

  const folderRefresh = async () => {
    let folderResponse = await getallFolder(false, false);
    updateListofFolders(folderResponse.data, 'fetchAllFolders');
  };

  const lockUnlockTemplateHandler = async (
    currentTemplateId,
    lockType,
    isUnLock = false,
    isReadOnly = false,
  ) => {
    const templateStatus = await getTemplateLockStatus(currentTemplateId, lockType);
    if (templateStatus) {
      if (templateStatus?.data) {
        let lockedStatus = templateStatus?.data;
        if (parseInt(lockedStatus?.user_id) === userDetails?.id) {
          setIsTemplateEditable(true);
          setOpenLockedModal(false);
        } else {
          if (!isUnLock) {
            setLockedUserName(lockedStatus?.user_name);
            setIsTemplateEditable(false);
            setOpenLockedModal(true);
          }
        }
      } else if (templateStatus.statusCode === 740) {
        setLockedUserId(null);
        if (isUnLock) {
          if (parseInt(lockedUserId) === parseInt(userDetails?.id)) {
            setLockedUserName(null);
            setOpenLockedModal(false);
            unlockTemplate(currentTemplateId, lockType);
            if (isReadOnly) {
              setIsTemplateEditable(false);
            }
          }
        } else {
          const response = await lockResource(currentTemplateId, lockType);
          setIsTemplateEditable(true);
          setOpenLockedModal(false);
          if (response && response?.data) {
            setLockedUserId(response?.data?.user_id);
          }
        }
      }
    }
  };

  const updateGlobalVariables = async (variables, updationType) => {
    switch (updationType) {
      case 'fetchAllVariables':
        if (variables === null) {
          let getVariableResponse = await getAllVariables();
          if (
            getVariableResponse &&
            getVariableResponse.errors &&
            getVariableResponse.errors.length === 0
          ) {
            setGlobalVariables(getVariableResponse.data);
            setVariablesFetched(true);
          } else {
            setVariablesFetched(true);
          }
        } else {
          setGlobalVariables(variables);
          setVariablesFetched(true);
        }
        break;
      case 'addNewVariable':
        let response = await saveVariable(variables);
        if (response && response.errors && response.errors.length === 0) {
          const newVar = Object.assign({}, variables, { id: response.id });
          const newList = [...globalVariables, newVar];
          setGlobalVariables(newList);
          return [newVar, newList];
        }
        break;
      default:
        break;
    }
  };

  const updateRefElementName = name => {
    setSaveElementName(name);
  };

  const setRefElementDetails = e => {
    setElementDetails(e);
    if (e?.thumbnail) {
      const split = e.thumbnail.split('=');
      let thumbnailId = parseInt(split[1]);
      setThumbnailId(thumbnailId);
    } else {
      setThumbnailId(undefined);
    }
  };
  const getReferenceThumbnailId = e => {
    setThumbnailId(e);
  };

  const getTemplateList = async (
    contentType,
    isMaster,
    isEmail,
    isShortMessage,
    page,
    searchName,
    searchTag,
    filterCateg,
    forApproval,
    cb = () => { },
    selectedLanguage,
  ) => {
    if (forApproval && (contentType !== 'createFlow' && contentType !== 'createBlock')) {
      if (!isEmail) {
        let approvalTemp = await waitForApproval(
          page,
          checkUserAccess('client') ? 'usertemplate' : 'mastertemplate',
          searchName,
          searchTag,
          filterCateg,
        );
        let allDocTemplates = await getAllTemplate(
          '',
          checkUserAccess('client') ? 'usertemplate' : 'mastertemplate',
        );
        if (approvalTemp && approvalTemp.data) {
          var approvalTemplates = allDocTemplates.data.filter(Obj => {
            return approvalTemp.data.some(item => {
              return Obj.id === item.id;
            });
          });
          setTemplatesList(page > 1 ? templatesList.concat(approvalTemplates) : approvalTemplates);
          setTotalTemplates(approvalTemp.dataCount);
          cb();
        }
        setFetchingCategories(false);
      } else {
        let approvalTemp = await waitForApprovalEmail(
          page,
          searchName,
          searchTag,
          filterCateg,
          'write',
        );
        if (approvalTemp && approvalTemp.data) {
          setTemplatesList(page > 1 ? templatesList.concat(approvalTemp.data) : approvalTemp.data);
          setTotalTemplates(approvalTemp.dataCount);
          cb();
        } else if (approvalTemp && approvalTemp.data === null) {
          let templates = [];
          setTemplatesList(templates);
          setTotalTemplates(templates.length);
          cb();
        }
        setFetchingCategories(false);
      }
    } else {
      if (contentType === 'Docs') {
        if (isMaster) {
          let userTemplateResp = await getTemplateByCategory(
            page,
            'mastertemplate',
            searchName,
            null,
            filterCateg,
          );
          if (userTemplateResp && userTemplateResp.data) {
            let templates =
              page > 1 ? templatesList.concat(userTemplateResp.data) : userTemplateResp.data;
            setTemplatesList(templates);
            setTotalTemplates(userTemplateResp.dataCount);
            cb();
          }
          setFetchingCategories(false);
        } else {
          if (!isEmail) {
            if (isShortMessage) {
            } else {
              let userTemplateResp = await getTemplateByCategory(
                page,
                checkUserAccess('client') ? 'usertemplate' : 'mastertemplate',
                searchName,
                searchTag,
                filterCateg,
                selectedLanguage,
              );
              if (userTemplateResp && userTemplateResp.data) {
                let templates =
                  page > 1 ? templatesList.concat(userTemplateResp.data) : userTemplateResp.data;
                setTemplatesList(templates);
                setTotalTemplates(userTemplateResp.dataCount);
                cb();
              }
              setFetchingCategories(false);
            }
          } else {
            let userTemplateResp = await getAllMailTemplates(
              page,
              false,
              searchName,
              searchTag,
              filterCateg,
              '',
              '',
              'write',
            );
            if (userTemplateResp && userTemplateResp.data) {
              let templates =
                page > 1 ? templatesList.concat(userTemplateResp.data) : userTemplateResp.data;
              setTemplatesList(templates);
              setTotalTemplates(userTemplateResp.dataCount);
              cb();
            }
            else if (userTemplateResp && userTemplateResp.data === null) {
              let templates = [];
              setTemplatesList(templates);
              setTotalTemplates(templates.length);
              cb();
            }
            setFetchingCategories(false);
          }
        }
      } else if (contentType === 'MasterMailDocs') {
        let userTemplateResp = await getAllMailTemplates(
          page,
          false,
          searchName,
          searchTag,
          filterCateg,
          'master',
          '',
          'write',
        );
        if (userTemplateResp && userTemplateResp.data) {
          let templates =
            page > 1 ? templatesList.concat(userTemplateResp.data) : userTemplateResp.data;
          setTemplatesList(templates);
          setTotalTemplates(userTemplateResp.dataCount);
          cb();
        } else if (userTemplateResp && userTemplateResp.data === null) {
          let templates = [];
          setTemplatesList(templates);
          setTotalTemplates(templates.length);
          cb();
        }
        setFetchingCategories(false);
      } else if (contentType === 'call' || contentType === 'sms' || contentType === 'whatsapp') {
        let userTemplateResp = await getAllTemplates(
          filterCateg,
          contentType,
          searchName,
          searchTag,
          page,
          selectedLanguage,
        );
        if (userTemplateResp && userTemplateResp.data) {
          let templates =
            page > 1 ? templatesList.concat(userTemplateResp.data) : userTemplateResp.data;
          setTemplatesList(templates);
          const totalCount = userTemplateResp.dataCount;
          setTotalTemplates(totalCount);
          cb();
        }
        setFetchingCategories(false);
      }
    }
  };

  const checkUserAccess = (userType, roles) => {
    if (roles) {
      return (
        userDetails?.userType === userType && userDetails?.roles?.some(role => roles.includes(role))
      );
    } else {
      return userDetails?.userType === userType;
    }
  };
  const checkUserAccessRoles = (roles) => {
    return userDetails?.roles?.some(role => roles.includes(role));
  };

  const upgradeUserPlan = (async () => {
    const response = await createCustomerPortal();
    if (response) {
      window.open(response.updatePlanUrl, '_blank');
    }
  })

  useEffect(() => {
    console.log("REACT_APP_OPENREPLAY_ID :: ", process.env.REACT_APP_OPENREPLAY_ID);
    if (onboardingStatus) {
      const tracker = new OpenReplay({
        projectKey: process.env.REACT_APP_OPENREPLAY_ID,
        ingestPoint: process.env.REACT_APP_OPENREPLAY_INGESTPOINT,
        __DISABLE_SECURE_MODE: OPENREPLAY_DISABLE_SECURE_MODE

      });
      tracker.use(trackerAssist({}));
      tracker.start();
      tracker.setUserID(userDetails?.email)
    }
  }, [onboardingStatus])

  const getFontFamily = async str => {
    try {
      const payload = {
        format: 'text',
        text: str,
      };
      let languageResp = await detectLanguage(payload);
      if(languageResp && languageResp.data && languageResp.errors && languageResp.errors.length === 0) {
        let detectedLang = languageResp.data;
        return detectedLang;
      }
    } catch (error) {
      setFailedStep(2);
    }
  };

  const genrateOverflowPage = (arrayOfPages, detectedLangResp) => {
    let detectedLanguage = detectedLangResp?.sourceLanguage;
    let fontFamily = detectedLangResp?.supportedFont;
    let fontSize = 16;
    let textAlign = 'left';
    const rtlLanguages = ["ar", "dv", "he", "ku", "fa", "ur"]; /// content should be written from right to left for these  languages
    if (rtlLanguages.includes(detectedLanguage)) {
      textAlign = 'right';
    }
    let paragraphElement = {
      tagName: 'paragraph',
      tagStyles: {
        translateX: 25,
        translateY: 200,
        backgroundColor: [0, 0, 0, 0],
        color: [0, 0, 0],
        alignment: textAlign,
        lineSpacing: 1.5,
        letterSpacing: 0,
        family: fontFamily,
        size: fontSize,
        rotate: 0,
      },
      text: [
        {
          bold: false,
          italic: false,
          underLined: false,
          backgroundColor: [0, 0, 0, 0],
          color: [0, 0, 0],
          size: fontSize,
          letterSpacing: 0,
          isAIText: true,
          textValue: 'Sample Text',
          variableDetails: {
            isVariable: false,
            variableId: null,
            name: null,
            maxLength: null,
          },
          family: fontFamily,
        },
      ],
    };
    let pages = {
      width: 794,
      height: 1123,
      backgroundColor: [255, 255, 255],
      family: 'Open Sans',
      'transform-origin': '0px 0px',
      scale: 1,
      'right-margin': 0,
      'left-margin': 0,
      'top-margin': 0,
      'bottom-margin': 0,
      elements: [],
    };
    let textElement;
    let listOfPages = [];
    for (var i = 0; i < arrayOfPages.length; i++) {
      let elementsByPages = [];
      let splittedPages = arrayOfPages[i]?.split('\n');
      for (var x = 0; x < splittedPages.length; x++) {
        textElement = JSON.parse(JSON.stringify(paragraphElement));
        if (i > 0) {
          textElement.tagStyles.height = 1025;
          textElement.tagStyles.translateY = 25;
        }
        textElement.text[0].textValue = splittedPages[x];
        elementsByPages.push(textElement);
      }
      let aiElement = {
        tagName: 'block',
        tagStyles: {
          width: 750,
          translateX: 25,
          translateY: i > 0 ? 25 : 200,
          rotate: 0,
          scaleX: 1,
          scaleY: 1,
          'z-index': '0',
          outline: 'none',
        },
        blockElements: [],
      };
      aiElement.blockElements = elementsByPages;
      listOfPages.push(aiElement);
    }
    let pagesArray = [];
    for (var n = 0; n < listOfPages.length; n++) {
      let pagesCopy = JSON.parse(JSON.stringify(pages));
      pagesCopy.elements = [{ ...listOfPages[n] }];
      pagesArray.push(pagesCopy);
    }
    setAICurrentStep(2);
    return pagesArray;
  };

  const generateDesignText = async () => {
    setAICurrentStep(1);
    let aiBorder = {
      tagStyles: {
        translateX: -6.42473,
        translateY: -33.1194,
        scaleX: 1,
        rotate: 4.43535,
        scaleY: 1,
        width: 886.3,
        height: 82.975,
        backgroundColor: [0, 0, 0, 0],
      },
      uiType: 'rectangle',
      tagValue:
        '<svg xmlns="http://www.w3.org/2000/svg" width="886.3px" height="82.975px" viewBox="0 0 886.3 82.975" version="1.2" data-border-width="null" data-border-radius="null" style="undefined;width:886.312px;height:138.98700000000002px;;width:886.3px;height:82.975px;;width:886.3px;height:82.975px;"><defs><clipPath id="clip1"><path d="M 0 0 L 886.3 0 L 886.3 82.975 L 0 82.975 Z M 0 0"></path></clipPath></defs><g id="surface1"><g clip-path="url(#clip1)" clip-rule="nonzero"><path style=" stroke:none;fill-rule:nonzero;fill:#f5a623;;;;fill-opacity:1.00" d="M 0 0 L 886.3 0 L 886.3 82.975 L 0 82.975  Z M 0 0"></path></g></g></svg>',
      tagName: 'svg',
    };

    let aiImage = {
      tagStyles: {
        backgroundColor: [0, 0, 0, 0],
        width: 125,
        height: 125,
        translateX: 25,
        translateY: 40,
        zIndex: 9,
        rotate: 0,
        scaleX: 1,
        scaleY: 1,
      },
      uiType: 'image',
      tagValue: 'https://docstudio-dev.tekclansolutions.com/api/DocStudio/image?id=1408',
      tagName: 'image',
    };
    let response = await generateTextFromData(generateContentForText);
    if (response.statusCode === 2201) {
      let str = response.data.choices[0].text;
      str = new DOMParser().parseFromString(str, 'text/html').documentElement.textContent;
      let getOnestr = str.split('\n');
      getOnestr = getOnestr.filter(value => value !== '');
      let pagesList = [];
      let detectedLangForText = await getFontFamily(getOnestr[0]).then(data => {
        return data;
      });
      let splittedAray = getSplittedArray(str, detectedLangForText);
      pagesList = genrateOverflowPage(splittedAray, detectedLangForText);
      if (pagesList?.length === 0) {
        setFailedStep(2);
      } else if (pagesList?.length > 0) {
        let payloadArray = JSON.parse(JSON.stringify(pagesList));
        payloadArray[0].elements = [...payloadArray[0].elements, { ...aiImage }, { ...aiBorder }]; /// for first page alone
        let payload = {
          pages: [],
        };
        payload.pages = payloadArray;
        setAIGeneratedContent(payload);
        const aiCopyElement = document.getElementById("aiContentGeneration");
        if(aiCopyElement) {
          aiCopyElement.remove();
        }
      }
    } else {
      setFailedStep(1);
      if(response.statusCode === 2204) {
        message.error('The text generation limit for this subscription plan has been reached');
      }
    }
  };

  const getSplittedArray = (str, detectedLang) => {
    let finalArray = [];
    let myContainer = 'aiContentGeneration';
    let textArray;
    const newAIDiv = document.createElement("div");
    newAIDiv.setAttribute("id", myContainer);
    newAIDiv.setAttribute("style", `width: 750px; height: 850px; font-size: 16px; font-family: ${detectedLang?.supportedFont}`);
    document.body.appendChild(newAIDiv);
    newAIDiv.innerText = str;
    do {
      textArray = splitTextOnOverflow(myContainer);
      textArray?.length === 1 && finalArray.push(...textArray);
      if (textArray?.length > 1) {
        finalArray.push(textArray[0]);
        newAIDiv.setAttribute("style", "height: 900px;");
        myContainer = 'aiContentGeneration';
      }
    } while (textArray.length > 1);
    return finalArray;
  }

  const splitTextOnOverflow = (containerId) => {
    const container = document.getElementById(containerId);
    const originalText = container.innerText;
    const maxWidth = container.clientWidth;
    const maxHeight = container.clientHeight;
    let newText = originalText;
    const textArray = [];
    while (container.scrollWidth > maxWidth || container.scrollHeight > maxHeight) {
      newText = newText.slice(0, -1); // Remove the last character
      container.innerText = newText;
    }
    textArray.push(container.innerText);
    if(container.innerText !== originalText) {
      newText = originalText.slice(container.innerText.length);
      container.innerText = newText;
      textArray.push(container.innerText);
    }
    return textArray;
  };

  const defaultOptionsDoc = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const defaultOptionsGenAI = {
    loop: true,
    autoplay: true,
    animationData: generateAIData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const defaultOptionsWriteAI = {
    loop: true,
    autoplay: true,
    animationData: writingAIData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  useEffect(() => {
    aiDataCurrentStep && openAINotification(aiDataCurrentStep, failedStep);
    if(failedStep !== null) {
      setTimeout(() => {
        setFailedStep(null);
        setAICurrentStep(null);
        if (failedStep !== 0) {
          setAIGenerateText(false);
          setGenerateContentForText('');
        }
        setAIGeneratedContent(undefined);
        notification.close('generateAIContent');
        history.push('/documentTemplates');
      }, 5000);
    }
  }, [aiDataCurrentStep, failedStep]);

  const lottieIcon = (data, id, currentStep, failedStep) => {
    return (
      <Lottie
        options={data}
        className="lottie"
        height="100%"
        width="100%"
        speed={1}
        isStopped={id !== currentStep || id === failedStep}
        isPaused={false}
      />
    );
  };

  const openAINotification = (aiCurrentStep, failedStep) => {
    const key = 'generateAIContent';
    notification.open({
      message: (
        <AIGenerationSteps current={aiCurrentStep}>
          <Step
            description={
              failedStep === 0 ? (
                <div className='failedStep'>
                  <Icon type='close-circle'/> Unable to Create the document
                </div>
              ) : (
                <div className={aiCurrentStep === 0 ? 'processing' : 'waitOrFinish'}>
                  <Icon
                    type={aiCurrentStep === 0 ? 'loading' : aiCurrentStep > 0 ? 'check-circle' : ''}
                  />
                  Creating the document
                </div>
              )
            }
            icon={lottieIcon(defaultOptionsDoc, 0, aiCurrentStep, failedStep)}
          />
          <DividerLine finish={aiCurrentStep > 0}><p/></DividerLine>
          <Step
            description={
              failedStep === 1 ? (
                <div className='failedStep'>
                  <Icon type='close-circle'/> Unable to Generate the content
                </div>
              ) : (
                <div className={aiCurrentStep === 1 ? 'processing' : 'waitOrFinish'}>
                  <Icon
                    type={aiCurrentStep === 1 ? 'loading' : aiCurrentStep > 1 ? 'check-circle' : ''}
                  />
                  Generating the AI content
                </div>
              )
            }
            icon={lottieIcon(defaultOptionsGenAI, 1, aiCurrentStep, failedStep)}
          />
          <DividerLine finish={aiCurrentStep > 1}><p/></DividerLine>
          <Step
            description={
              failedStep === 2 ? (
                <div className='failedStep'>
                  <Icon type='close-circle'/> Unable to write the content
                </div>
              ) : (
                <div className={aiCurrentStep === 2 ? 'processing' : 'waitOrFinish'}>
                  <Icon type={aiCurrentStep === 2 ? 'loading' : ''} /> Writing the content for you
                </div>
              )
            }
            icon={lottieIcon(defaultOptionsWriteAI, 2, aiCurrentStep, failedStep)}
          />
        </AIGenerationSteps>
      ),
      description: '',
      key,
      duration: 0,
      placement: 'topLeft',
      className: 'generateAIContent',
    });
  };

  return (
    <AppStoreContext.Provider
      value={{
        categoryElements,
        updateCategoryElements,
        categoryTemplates,
        updateCategoryTemplates,
        editorTemplates,
        updateEditorTemplate,
        loginVisible,
        setLoginVisible,
        emailVerificationVisible,
        setEmailVerificationVisible,
        documentVisible,
        setDocumentVisible,
        folderList,
        updateListofFolders,
        userPermission,
        setUserPermission,
        isTemplateEditable,
        setIsTemplateEditable,
        openLockedModal,
        setOpenLockedModal,
        lockedUserName,
        lockUnlockTemplateHandler,
        error,
        errorInfo,
        setError,
        setErrorInfo,
        globalVariables,
        updateGlobalVariables,
        documentVariables,
        setDocumentVariables,
        updateRefElementName,
        saveElementName,
        setSaveElementName,
        setRefElementDetails,
        setElementDetails,
        elementDetails,
        thumbnailId,
        setThumbnailId,
        getReferenceThumbnailId,
        setElementPageDetail,
        elementPageDetail,
        setTemplatesList,
        templatesList,
        getTemplateList,
        setTotalTemplates,
        totalTemplates,
        fetchingCategories,
        setFetchingCategories,
        resourceGroupId,
        setResourceGroupId,
        windowZoom,
        setWindowZoom,
        variablesFetched,
        setSession,
        hasSession,
        ChekOutVerification,
        setChekOutVerification,
        userDetails, setUserDetails,
        onboardingStatus, setOnboardingStatus,
        checkUserAccess,
        checkUserAccessRoles,
        sessionExist,
        updateSessionExists,
        pageUpdationDetail,
        setPageUpdationDetail,
        upgradeUserPlan,
        isAIGenerateText,
        setAIGenerateText,
        generateContentForText,
        setGenerateContentForText,
        generateDesignText,
        aiGeneratedContent,
        setAIGeneratedContent,
        setPagesUpdatedByAI,
        pagesUpdatedByAI,
        setAICurrentStep,
        aiDataCurrentStep,
        openAINotification,
        setFailedStep,
        isEnterprise,
        setIsEnterprise,
        upgradeUserPlan,
        countryList,
        setCountryList,
        organisationSetupPage,
        setOrganisationSetUpPage,
        isLicenseExpired,
        setIsLicenseExpired,
        planType,
        isLdapConfigured,
        setIsLdapConfigured,
        ssoAuthClient,
        setAuthClient,
        ssoSetup,
        setSSOSetup,
        languageList,
        setLanguageList,
        licenseDetails,
        setLicenseDetails,
        sessionExpired,
        setSessionExpired,
        reAuthenticate,
        setReAuthenticate
      }}
    >
      {children}
    </AppStoreContext.Provider>
  );
};

export default AppStoreProvider;
